/**
 * Canonical prime JSON basenames under `Krysalis_Backend/docs/artifacts/prime/` (backend source of truth).
 * Six workspace primes; superseded names and interim trackers live under `archive/pre-workspace-sync-20260408/`.
 * @see Krysalis_Backend docs/artifacts/prime/README.md
 * @see Krysalis_Backend docs/artifacts/prime/project_file_inventory.md
 */
export const CANONICAL_PRIME_JSON = {
  companyNavigator: 'company_navigator.json',
  krysalisPlatform: 'krysalis_platform.json',
  investmentCompanyNavigator: 'investment_company_navigator.json',
  personalNavigator: 'personal_navigator.json',
  productComponents: 'product_components.json',
  krysalisDealNavigator: 'krysalis_deal_navigator.json',
} as const;

/** All canonical basenames (for allowlists and file pickers). */
export const CANONICAL_PRIME_BASENAMES: readonly string[] = Object.freeze(
  Object.values(CANONICAL_PRIME_JSON) as string[],
);
